import type { QueryKey } from '@tanstack/vue-query';

export const fileKeys = {
  all: ['files'] as const,

  urls: () => [...fileKeys.all, 'url'] as const,
  url: (scope: QueryKey, fileId: number) => [...fileKeys.urls(), ...scope, fileId] as const,

  images: () => [...fileKeys.all, 'image'] as const,
  image: (scope: QueryKey, source: number | string | null | undefined) =>
    [...fileKeys.images(), ...scope, source] as const,
};
